import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems } from '../data/content';
export function Difference() {
  return <section className="w-full bg-background px-5 py-20 sm:py-28" data-id="element-55" data-mp="e3didugelir3">
      <div className="mx-auto max-w-5xl" data-id="element-56" data-mp="9mjdg0ath9m">
        <div className="mx-auto max-w-3xl text-center" data-id="element-57" data-mp="598v1l0hapgb">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-success" data-id="element-58" data-mp="57o0vwi2t8iz">
            Une meilleure façon d&apos;enseigner la musique
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-foreground sm:text-5xl" data-id="element-59" data-mp="3rgp9s58bbjis">
            De l&apos;Enseignant Débordé au{' '}
            <span className="italic text-emphasis" data-id="element-60" data-mp="3ifr0p8j0oltc">Guide Inspirant.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-foreground/60 sm:text-base" data-id="element-61" data-mp="3ihlnksdumo02">
            Des heures de planification remplacées par un système «&nbsp;ouvrez
            et enseignez&nbsp;».
          </p>
        </div>

        <div className="mt-10 overflow-hidden rounded-3xl bg-surface shadow-card" data-id="element-62" data-mp="1ja40d8mn90fz">
          <div className="grid md:grid-cols-2" data-id="element-63" data-mp="1fa3itf49094p">
            <div className="relative bg-muted p-8 sm:p-10" data-id="element-64" data-mp="1f9brighooxk8">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-surface text-foreground/35" data-id="element-65" data-mp="1szx9m2zbd3h2">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-66" data-mp="1o486xqrzz6gj" />
              </span>
              <h3 className="max-w-[14rem] font-display text-2xl font-bold tracking-wide text-foreground" data-id="element-67" data-mp="10eduvbfi5lxc">
                AVANT
              </h3>
              <p className="mt-2 max-w-xs text-xs leading-relaxed text-foreground/55" data-id="element-68" data-mp="1aaqzv5ghzm7e">
                L&apos;ancienne méthode épuisante.
              </p>
              <ul className="mt-6 space-y-3" data-id="element-69" data-mp="15dh314qs489j">
                {beforeItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-surface/80 px-4 py-3 text-sm text-foreground/60" data-id="element-70" data-mp="2lrqrdyv0tx0d">
                    <CircleXIcon className="mt-0.5 h-4 w-4 shrink-0 text-foreground/30" aria-hidden="true" data-id="element-71" data-mp="2oqzaocwuv2fo" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-surface p-8 sm:p-10" data-id="element-72" data-mp="32pp7drfrj03i">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-success text-surface" data-id="element-73" data-mp="253jhgho14hnr">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-74" data-mp="2a34daj7wk9w9" />
              </span>
              <h3 className="max-w-[16rem] font-display text-2xl font-bold tracking-wide text-foreground" data-id="element-75" data-mp="2f0nunrzwd2sf">
                AVEC MUSIQUE PRÊTE™
              </h3>
              <p className="mt-2 max-w-xs text-xs leading-relaxed text-foreground/55" data-id="element-76" data-mp="1md1nyavdhi1c">
                Votre nouvelle réalité.
              </p>
              <ul className="mt-6 space-y-3" data-id="element-77" data-mp="1raa9mlfqc47c">
                {afterItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-subtle px-4 py-3 text-sm font-medium text-foreground" data-id="element-78" data-mp="1jr13r26fmnn1">
                    <CircleCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-success" aria-hidden="true" data-id="element-79" data-mp="19suz4ct8r3eh" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}